import { useDispatch } from 'react-redux'
import { subscriptionRtkApi } from '@/services/subscriptionRtkApi'
import { accessLimitsRtkApi } from '@/services/accessLimitsRtkApi'
import { verificationRtkApi } from '@/services/verificationRtkApi'
import { statsApi } from '@/services/statsApi'
import { profileViewApi } from '@/services/profileViewApi'

export const useCacheInvalidation = () => {
    const dispatch = useDispatch()

    const invalidateSubscriptionCache = () => {
        dispatch(subscriptionRtkApi.util.invalidateTags(['Subscription', 'PaymentHistory']))
    }

    const invalidateAccessLimitsCache = () => {
        dispatch(accessLimitsRtkApi.util.invalidateTags(['AccessLimits']))
    }

    const invalidateVerificationCache = () => {
        dispatch(verificationRtkApi.util.invalidateTags(['Verification']))
    }

    const invalidateStatsCache = () => {
        dispatch(statsApi.util.invalidateTags(['DashboardStats', 'UserStats', 'PlatformStats']))
    }

    const invalidateProfileViewCache = () => {
        dispatch(profileViewApi.util.invalidateTags(['ProfileViews']))
    }

    const invalidateAllCaches = () => {
        invalidateSubscriptionCache()
        invalidateAccessLimitsCache()
        invalidateVerificationCache()
        invalidateStatsCache()
        invalidateProfileViewCache()
    }

    const resetAllCaches = () => {
        dispatch(subscriptionRtkApi.util.resetApiState())
        dispatch(accessLimitsRtkApi.util.resetApiState())
        dispatch(verificationRtkApi.util.resetApiState())
        dispatch(statsApi.util.resetApiState())
        dispatch(profileViewApi.util.resetApiState())
    }

    const invalidateUserDataCaches = () => {
        invalidateSubscriptionCache()
        invalidateAccessLimitsCache()
        invalidateVerificationCache()
        invalidateStatsCache()
    }

    return {
        invalidateSubscriptionCache,
        invalidateAccessLimitsCache,
        invalidateVerificationCache,
        invalidateStatsCache,
        invalidateProfileViewCache,
        invalidateAllCaches,
        resetAllCaches,
        invalidateUserDataCaches,
    }
}
